import { defineMessages } from 'react-intl';

export default defineMessages({
  appError: {
    id: 'app.components.Loading.appError',
    defaultMessage: 'An error prevented the page from loading',
  },
  timedOut: {
    id: 'app.components.Loading.timedOut',
    defaultMessage: 'Something is taking a long time...',
  },
  notFound: {
    id: 'app.components.Loading.notFound',
    defaultMessage: 'The page you requested does not exist',
  },

  buttonReloadApp: {
    id: 'app.components.Loading.buttonReloadApp',
    defaultMessage: 'Reload app',
  },
  buttonDashboard: {
    id: 'app.components.Loading.buttonDashboard',
    defaultMessage: 'Go to dashboard',
  },
  buttonSupport: {
    id: 'app.components.Loading.buttonSupport',
    defaultMessage: 'Contact support',
  },
  buttonLogout: {
    id: 'app.components.Loading.buttonLogout',
    defaultMessage: 'Logout',
  },
});
